import React, { lazy } from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Send, MessageCircle, Phone, Mail, MapPin } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';
export function Contact() {
  const {
    t
  } = useLang();
  return <Section id="contact" background="gray" data-id="element-29">
      <div className="grid md:grid-cols-2 gap-12 lg:gap-24 relative z-10" data-id="element-30">
        {/* Left: contact info */}
        <div data-id="element-31">
          <h2 className="text-3xl md:text-5xl font-bold text-black mb-6 md:mb-8" data-id="element-32">
            {t('contact_h2')}
          </h2>
          <p className="text-neutral-500 mb-8 md:mb-12 text-base md:text-lg font-light max-w-md" data-id="element-33">
            {t('contact_subtitle')}
          </p>

          <div className="space-y-6 md:space-y-8 mb-8 md:mb-12" data-id="element-34">
            <div data-id="element-35">
              <p className="text-xs font-bold text-black uppercase tracking-wider mb-2 md:mb-3 flex items-center gap-2" data-id="element-36">
                <Phone className="h-3 w-3" data-id="element-37" />
                {t('contact_phone_label')}
              </p>
              <a href="tel:+380500000000" className="text-xl md:text-2xl text-black hover:text-neutral-600 transition-colors block break-words" data-id="element-38">
                +380 50 000 00 00
              </a>
            </div>

            <div data-id="element-39">
              <p className="text-xs font-bold text-black uppercase tracking-wider mb-2 md:mb-3 flex items-center gap-2" data-id="element-40">
                <Mail className="h-3 w-3" data-id="element-41" />
                {t('contact_email_label')}
              </p>
              <a href="mailto:info@buhgalter.ua" className="text-xl md:text-2xl text-black hover:text-neutral-600 transition-colors block break-all" data-id="element-42">
                info@buhgalter.ua
              </a>
            </div>

            <div data-id="element-43">
              <p className="text-xs font-bold text-black uppercase tracking-wider mb-2 md:mb-3 flex items-center gap-2" data-id="element-44">
                <MapPin className="h-3 w-3" data-id="element-45" />
                {t('contact_office_label')}
              </p>
              <p className="text-xl md:text-2xl text-black" data-id="element-46">
                м. Київ, вул. Велика Васильківська, 72
              </p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 md:gap-4" data-id="element-47">
            <Button variant="outline" className="flex-1 justify-between group text-sm md:text-base" onClick={() => window.open('https://t.me/buhgalter_ua', '_blank')} data-id="element-48">
              <span data-id="element-49">Telegram</span>
              <Send className="h-4 w-4 text-neutral-400 group-hover:text-black group-hover:translate-x-1 transition-all" data-id="element-50" />
            </Button>
            <Button variant="outline" className="flex-1 justify-between group text-sm md:text-base" onClick={() => window.open('https://wa.me/380500000000', '_blank')} data-id="element-51">
              <span data-id="element-52">WhatsApp</span>
              <MessageCircle className="h-4 w-4 text-neutral-400 group-hover:text-black group-hover:scale-110 transition-all" data-id="element-53" />
            </Button>
          </div>
        </div>

        {/* Right: Google Maps embed */}
        <div className="border border-neutral-200 overflow-hidden bg-neutral-50 h-[400px] md:h-full min-h-[400px]" data-id="element-54">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2541.4!2d30.5234!3d50.4501!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40d4ce56b3c5b7b7%3A0x0!2z0JLQtdC70LjQutCwINCS0LDRgdC40LvRjNC60ZbQstGB0YzQutCwLCA3MiwgS3lpdiwgVWtyYWluZQ!5e0!3m2!1suk!2sua!4v1700000000000!5m2!1suk!2sua&q=вул.+Велика+Васильківська+72+Київ" width="100%" height="100%" style={{
          border: 0,
          display: 'block',
          minHeight: '400px'
        }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Офіс на карті" data-id="element-55"></iframe>
        </div>
      </div>
    </Section>;
}